export const STRIPE_PROCESSOR = 'stripe';
export const STRIPE_PROVIDER_ID = 4;

const BRAINTREE_AMEX = 'American Express';
const BRAINTREE_DISCOVER = 'Discover';
const BRAINTREE_JCB = 'JCB';
const BRAINTREE_MASTERCARD = 'Mastercard';
const BRAINTREE_VISA = 'Visa';
const STRIPE_AMEX = 'amex';
const STRIPE_DISCOVER = 'discover';
const STRIPE_JCB = 'jcb';
const STRIPE_MASTERCARD = 'mastercard';
const STRIPE_VISA = 'visa';

export const STRIPE_FORM_CONTEXT = {
  prepay: 'prepay',
  concierge: 'concierge',
  booking: 'booking',
  profile: 'profile',
};

export const BRAINTREE_COMMON_TYPES = [BRAINTREE_AMEX, BRAINTREE_DISCOVER, BRAINTREE_JCB, BRAINTREE_MASTERCARD, BRAINTREE_VISA];
export const STRIPE_COMMON_TYPES = [STRIPE_AMEX, STRIPE_DISCOVER, STRIPE_JCB, STRIPE_MASTERCARD, STRIPE_VISA];
